import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DateValue } from 'components/Filters/Date'
import { PopOverItem } from 'components/PopOver/types'
import { AppState } from 'store'
import { CallPerformanceFilters } from './types'

type State = {
  activeFilters: Array<CallPerformanceFilters.FilterNames>
  activityDate: DateValue['option']
  userGroup: PopOverItem[]
}

export const initialState: State = {
  activeFilters: ['activityDate'],
  activityDate: 'today',
  userGroup: [],
}

const slice = createSlice({
  name: 'report-callPerformance',
  initialState,
  reducers: {
    changedActiveFilters(draft, { payload: activeFilters }: PayloadAction<State['activeFilters']>) {
      const filterDifference = draft.activeFilters.filter((filter) => !activeFilters.includes(filter))

      filterDifference.forEach((filter) => {
        // Logic done this way because of TypeScript
        if (filter === 'activityDate') {
          draft[filter] = initialState[filter]
        } else if (filter === 'userGroup') {
          draft[filter] = initialState[filter]
        }
      })
      draft.activeFilters = activeFilters
    },
    changedActivityDate(draft, { payload: activityDate }: PayloadAction<State['activityDate']>) {
      draft.activityDate = activityDate
    },
    changedUserGroup(draft, { payload: userGroup }: PayloadAction<State['userGroup']>) {
      draft.userGroup = userGroup
    },
    clickedResetButton(draft) {
      draft.activeFilters = initialState.activeFilters
      draft.activityDate = initialState.activityDate
      draft.userGroup = initialState.userGroup
    },
  },
})

export const { changedActiveFilters, changedActivityDate, changedUserGroup, clickedResetButton } = slice.actions

export default slice.reducer

const getState = (state: AppState) => state.report.callPerformance

export const getCallPerformanceFilters = (state: AppState) => getState(state)
